import { createFileRoute } from '@tanstack/react-router';
import { ReadingPlans } from '@/components/Modules/ReadingPlans';

export const Route = createFileRoute('/plans')({
  component: ReadingPlans,
});
